import React from 'react';
import { Box, CTA } from 'react-scale/components';
import PricingItem from 'react-scale/components/pages/rapid/pricing/workforce-product-item';

const workforce = () => (
  <div className="items-center md:flex">
    <div className="md:w-2/5">
      <h2 className="mb-6 text-4xl font-aeonik">Workforce Labeling</h2>
      <p className="mb-8">
        With Workforce Labeling, trusted Taskers trained by Scale will label your data.
      </p>
      <p>Workforce Labeling is the best option if:</p>
      <ul className="mt-8">
        <li className="flex items-start mb-6">
          <img
            src="/static/images/components/ui/ul-check/check.svg"
            alt="Check"
            className="mt-1 mr-4"
          />
          You do not already have a dedicated team of trained taskers.
        </li>
        <li className="flex items-start mb-6">
          <img
            src="/static/images/components/ui/ul-check/check.svg"
            alt="Check"
            className="mt-1 mr-4"
          />
          You want consistent quality by investing upfront in developing labeling instructions
          without day-to-day worker management.
        </li>
        <li className="flex items-start mb-6">
          <img
            src="/static/images/components/ui/ul-check/check.svg"
            alt="Check"
            className="mt-1 mr-4"
          />
          You want to optimize for speed and simplicity.
        </li>
      </ul>
    </div>
    <div className="mt-16 sm:mt-0 md:ml-24 md:w-3/5">
      <Box>
        <h2 className="py-8 text-center">
          <span className="text-gradient text-overtitle-sm">Starting At</span>
        </h2>
        <ul className="border-t border-gray-800">
          <PricingItem
            imgSrc="/static/images/icons/products/image.svg"
            title="Scale Image"
            pricePerImage="2 ¢ per image"
            pricePerAnnotation="6 ¢ per annotation"
          />
          <PricingItem
            imgSrc="/static/images/icons/products/video.svg"
            title="Scale Video"
            pricePerImage="13 ¢ per video frame"
            pricePerAnnotation="3 ¢ per annotation"
          />
          <PricingItem
            imgSrc="/static/images/icons/products/text.svg"
            title="Scale Text"
            pricePerImage="5 ¢ per task"
            pricePerAnnotation="3 ¢ per annotation"
          />
          <PricingItem
            imgSrc="/static/images/icons/products/document.svg"
            title="Scale Document AI"
            pricePerImage="2 ¢ per task"
            pricePerAnnotation="7 ¢ per annotation"
          />
        </ul>
        <div className="flex justify-center p-8">
          <CTA
            cta={{
              buttons: [
                {
                  text: 'Label My Data',
                  href: 'https://dashboard.scale.com/signup?product=rapid'
                }
              ]
            }}
          />
        </div>
      </Box>
    </div>
  </div>
);

export default workforce;
